module.exports = __webpack_public_path__ + "static/media/GBR.ca7056bc.svg";